import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, shareReplay, switchMap } from 'rxjs/operators';
import { EnvironmentService } from '../../shared/services/environment.service';
import { ProjectService } from '../../shared/services/project.service';
import { IDestinationBox } from '../interfaces/idestination-box';

@Injectable({
  providedIn: 'root'
})
export class HolidayEngineService {
  private search = null;
  public search$ = new BehaviorSubject(this.search);

  constructor(private _http: HttpClient,
              private _projectService: ProjectService,
              private _environmentService: EnvironmentService) {
  }

  httpCache: Map<string, Observable<any>> = new Map<string, Observable<any>>();

  formatDestinationBox(destinationBox: any[], prefetchDestinationsList?: any[]): IDestinationBox[] {
    if (!prefetchDestinationsList?.length) return []; // Se non ci sono destinazioni derivanti dalla prefetch inutile proseguire
    return Object.entries(destinationBox).map(([group, destinations]) => {      
      let card: IDestinationBox;
      if (destinations?.length > 0) {
        destinations = destinations.filter((e) => (prefetchDestinationsList.find((i) => (i === parseInt(e.id_destinazione, 10)))));
      }
      if (destinations?.length > 0) {
        card = {
          name: group,
          destinations: destinations.map(e => ({id: parseInt(e.id_destinazione, 10), name: e.titolo}))
        };
      }
      return card;
    }).filter(x => x);
  }

  setData(key: string, value: any): void {
    this[key] = value;
    this[`${key}$`].next(this[key]);
  }

  getFormattedDestionationBox(prefetchDestinationsList?: any[]): Observable<any> {
    return this.getAgencyDestinationBox().pipe(
      switchMap(e => {
        if (!e || e.length === 0 ) {
          return this.getNetworkDestinationBox();
        }
        return of(e);
      }),
      map(e => this.formatDestinationBox(e, prefetchDestinationsList)),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getAgencyDestinationBox(): Observable<any> {
    return forkJoin([
      this._environmentService.getEnvironment(),
      this._projectService.getAgencyApikey(),
    ]).pipe(
      mergeMap(e => {
        const url = `${e[0].otoApiUrl}/index.php/holiday/${e[1]}/agency/destinationBox`;
        if (!this.httpCache.get(url)) {
          this.httpCache.set(url, this._http.get<any>(url).pipe(shareReplay({bufferSize: 1, refCount: true})));
        }
        return this.httpCache.get(url);
      }),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }

  getNetworkDestinationBox(): Observable<any> {
    return forkJoin([
      this._environmentService.getEnvironment(),
      this._environmentService.getNetworkApikey(),
    ]).pipe(
      mergeMap(e => {
        const url = `${e[0].otoApiUrl}/index.php/holiday/${e[1]}/agency/destinationBox`;
        if (!this.httpCache.get(url)) {
          this.httpCache.set(url, this._http.get<any>(url).pipe(shareReplay({bufferSize: 1, refCount: true})));
        }
        return this.httpCache.get(url);
      }),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }
}
